import React, {Component} from "react";
// import "./DownloadReport.css"
import "./DownloadReport.scss"
import InDatePicker from '../InDatePicker/InDatePicker'
import {schemaTypes,dateFormat,simpleTimeFormat} from '../../../../constants/constants'
import moment, { unix } from "moment";
import ReportAPIs from "../../../../APIs/ReportAPIs";
import Dom from '../../../../helpers/Dom';
import GroupNav from './GroupNav'
// import axios from 'axios';
import DatePicker from 'react-datepicker';
import DownloadToggle from '../../../../components/ToggleButton/downloadToggle'
import InMultiSelect from "../InMultiSelect/InMultiSelect";
import $ from 'jquery';

class DownloadReport extends Component{
    constructor(props){
        super(props)
        this.props = props
        // this.startDate = React.createRef();
        // this.endDate = React.createRef();
        this.state = {
            reporttype: "",
            requestSend: false,
            requestFailed:false,
            requestData:[],
            groups: [],
            selectedGroup:"",
            // showDisabled: false,
            DataExist : true,
            updateData : false,
            lastFetched:null,
            startDate: moment(Date.now()).startOf("day").subtract(1, "days").toDate(),
            endDate: moment(Date.now()).endOf("day").subtract(0, "days").toDate(),
            selected: false,
            dropdownOpen:false,
            limit:null,
            duration: null,
            singleselect: false,
        }
        this.group = []
        this.allIntervals = []
        this.timeIterval;

    }
    setTimer = (data,index) =>{
        let maxTime = 1800000
        // let maxTime = 120000
        let req_time = data.req_time;
        let current_time = Date.parse(new Date());
        let deadline = current_time - req_time; 
        if(deadline < 0) deadline = maxTime
        if(deadline < maxTime ){
            deadline = maxTime - deadline
            const timeRemaining = (endtime) =>{
                let t = endtime
                let seconds = Math.floor( (t/1000) % 60 );
                let minutes = Math.floor( (t/1000/60) % 60 );
                return {'total':t, 'minutes':minutes, 'seconds':seconds};
            }
            const runClock = (endtime) =>{
                const updateClock = () =>{
                    if(this.unmounted) return
                    endtime = endtime - 1000
                    let t = timeRemaining(endtime);
                    let reqData = this.state.requestData
                    if(reqData && reqData.length){
                        reqData[index].timer = t
                        this.setState({requestData: reqData})
                        if(t.total<1000){ clearInterval(this.timeinterval); }
                    }
                    
                }
                updateClock(); // run function once at first to avoid delay
                 this.timeinterval = setInterval(updateClock,1000);
                 this.allIntervals.push(this.timeinterval)
            }
            runClock(deadline);

        }
    }
    checkRequestTable = () =>{
        let groupid = this.state.selectedGroup.groupid
        if(groupid && groupid !== 0){
            let body = {
                groupid:groupid
            }
            this.setState({updateData:true})
            const handleSuccess = (resp)=> {
               let response =  resp.filter((rdata) =>{
                   if(rdata.status !== "Exists") return rdata
                })
                response = response.sort((a,b) => { return b.req_time - a.req_time})
                response.map((resData) => {
                    resData.endtime = resData.endtime - 1000
                })
                this.setState({requestData: response},() =>{
                    let time = moment(new Date()).format("DD-MM-YYYY HH:mm:ss")
                    setTimeout(() => {
                        if(this.state.updateData)this.setState({updateData:false,lastFetched:time})
                    },500)
                    // if(this.state.requestData){
                    //     this.state.requestData.map((data,index) => {
                    //         // if(data.status !== "Completed")this.setTimer(data,index)
                    //         if(data.status === "Completed" && !data.link){
                    //             this.download(data,index)
                    //         }
                    //     })
                    // }
                })
            }
            ReportAPIs.requestTableAPI(body)
            .then(handleSuccess)
        }
    }
    checkDownloadRequestTable = () =>{
        let groupid = this.state.selectedGroup.groupid
        if(groupid && groupid !== 0){
            let body = {
                groupid:groupid
            }
            const handleSuccess = (resp)=> {
                let response = resp
                if(response.length) {
                    let lastData = resp[resp.length - 1]
                    this.reqid = lastData.preqid
                    if(lastData.status === "Exists"){
                        
                        this.props.props.dispatch({
                            type: "ADD_INTOAST",
                            data: {
                            name: " Duplicate Request ",
                            content: "The last request is already availble on the table.",
                            createAt: Date.now(),
                            autoClose: 8000,
                            showError:true
                            },
                        });
                    }
                    response =  resp.filter((rdata) =>{
                        if(rdata.reqid == this.reqid){
                            rdata.color = "#ebdada"
                            this.reqid = null
                        }
                        if(rdata.status !== "Exists") return rdata
                    })
                    response = response.sort((a,b) => { return b.req_time - a.req_time})
                    response.map((resData) => {
                        resData.endtime = resData.endtime - 1000
                    })
                }
                this.setState({requestData: response},() =>{
                    // if(this.state.requestData){
                    //     this.state.requestData.map((data,index) => {
                    //         // if(data.status !== "Completed")this.setTimer(data,index)
                    //         if(data.status === "Completed" && !data.link){
                    //             this.download(data,index)
                    //         }
                    //     })
                    // }
                })
            }
            ReportAPIs.requestTableAPI(body)
            .then(handleSuccess)
        }
    }
    hide = (e)  => {
       if(this.state.dropdownOpen) this.setState({dropdownOpen:false})
    }
    componentDidMount(){
        // if(!window.comeBack){
        //     // document.getElementsByClassName("rwt-widget")[0].style.top="-40px"
        //     // window.comeBack = true
        //     // this.setState({comeBack: true})
        // }
        // else{
        //     // document.getElementsByClassName("rwt-widget")[0].style.top="0px"
        // }
        document.addEventListener('mousedown', (e)=>{
            let container = $(this.refs.reportContainer);
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                this.hide(e);
            }
        });
        window.$('.rw-container').css('top', '53px');
        let btn = document.getElementsByClassName("drcr-btn")
        let currentTime = moment(new Date()).unix()*1000
        let reqSendTime = localStorage.getItem('reportSendTime')
        if(reqSendTime && currentTime - reqSendTime > 30000){
            btn[0].disabled = false
            localStorage.removeItem("reportSendTime")
            this.setState({showDisabled: false, requestSend: false})
        }
        if(reqSendTime && currentTime - reqSendTime < 30000){
            this.setState({showDisabled: true, requestSend: true})
            btn[0].disabled = true
        }
        this.pgroupid = this.props && this.props.props &&
         this.props.props.groupTree && this.props.props.groupTree.children &&
          this.props.props.groupTree.children[0] ? this.props.props.groupTree.children[0].groupid : 0
        let group = this.props.props.groupTree

        this.groupname = this.props && this.props.props &&
            this.props.props.groupTree && this.props.props.groupTree.children &&
            this.props.props.groupTree.children[0] ? this.props.props.groupTree.children[0].name : ""
        let groups = []
        if(!group.path){
            group.path = "/0/"
            group.ppath = "/0/"
        }
        this.group = group;
        this.setState({groups: group},() => {
            this.navigate(group)
            this.checkRequestTable()
            
        })
        this.timeIterval =  setInterval(() => {
            if(this.state.requestData.length){
                let time = moment(new Date()).format("DD-MM-YYYY HH:mm:ss")
                this.setState({updateData:true,lastFetched:time})
            }
            this.checkRequestTable()
         },30000)
    }
    componentWillUnmount() {
        // document.getElementsByClassName("rwt-widget")[0].style.top="0px"
        window.comeBack = false
        clearInterval(this.timeIterval)
        this.unmounted = true
        window.$('.rw-container').attr('style', function(i, style)
        {
            return style && style.replace(/top[^;]+;?/g, '');
        });

    }
    componentWillReceiveProps(){
        let btn = document.getElementsByClassName("drcr-btn")
        let currentTime = moment(new Date()).unix()*1000
        let reqSendTime = localStorage.getItem('reportSendTime')
        if(reqSendTime && currentTime - reqSendTime > 30000){
            btn[0].disabled = false
            localStorage.removeItem("reportSendTime")
            this.setState({showDisabled: false, requestSend: false,requestFailed:false})
        }
        // this.state.requestData.map((data,index) =>{
        //     if(data.status === "Completed" && !data.link){
        //         this.download(data,index)
        //     }
        // })
    }
    reportName = [ "trip_report","daily_report","summary_report","distance","new_trip_report", "alarm_report", "range_report", "gps_report","immob_report","ebike_report"]
    reportHead= [
       {groupname : "Group Name", root_uname: "User", reporttype: "Report Type", starttime: "Start Time",endtime: "End Time",vehicleCount: "Vehicle Count",dayCount:"No. of Days", status:"Status", action:"Action"},
    ]

    addReportList = [
        {key:"distance", name:"Distance Report"},
        {key:"gpsdump", name:"Bulk GPS Report"},
        {key:"overspeed", name:"Over Speed Report"},

    ]
    endTimeTool = {
        key: "endtime",
        type: schemaTypes.DATE_PICKER,
        setIfNull: true,
        // hideTime : true,
        // model: moment(Date.now()).subtract(1, "day").startOf("day"),
      };
    startTimeTool = {
        key: "starttime",
        type: schemaTypes.DATE_PICKER,
        setIfNull: true,
        // hideTime: true,
        // model: moment(Date.now()).startOf("day").subtract(2, "days"),
      };
  
  toggleDropdown = () => {
    this.setState({dropdownOpen: !this.state.dropdownOpen});
  };

  handleOptionClick = (value,name) => {
    let overspeedSelected = false
    if(value === "overspeed"){
        overspeedSelected = true
    }
    if(value === 'gps_report') {
        this.setState({
            singleselect :true
        })
    }else {
        this.setState({
            singleselect:false
        })
    }
    this.setState({
      reporttype: value,
      reportName : name,
      requestSend: false,
      dropdownOpen: false,
      overspeedSelected:overspeedSelected,
    },() => {});
  };

  getReportType = () => {
    const enableImmob = window.userInfo?.SELF?.enable_immob_report;

    return this.props.allowedReports.map((report, index) => {
        if (report.key === "immob_report" && !enableImmob) {
            return null;
          }
      
      if (this.reportName.includes(report.key)) {
        return (
          <div
            key={index}
            className="dropdown-option"
            onClick={() => this.handleOptionClick(report.key,report.name)}
          >
            {report.name}
          </div>
        );
      }
      return null;
    });
  };
  
  addNewReport = () => {
    return this.addReportList.map((report,index) => {
        return(
            <div key={report.key} className="dropdown-option" onClick={() => this.handleOptionClick(report.key, report.name)}>
                {report.name}
            </div>
        )
    })
  }
    handleStartDate = (date) => {
        this.setState({startDate:date})
    }
    handleEndDate = (date) => {
        this.setState({endDate:date})
    }
    getSingleSelect = () => {
        return false
    }
    navigate = (group) => {
        let rootGroupPath = ""
        let path = group.path
        let pathArray = path.split("/");
        pathArray.splice(0,1);
        pathArray = pathArray.splice(0, pathArray.length-1);
        let currentPath = rootGroupPath;
        let nav = [];
        let currentNode = this.group;
        nav.push(currentNode);
        for(let idx in pathArray){
            currentPath += "/" + pathArray[idx];
            for(let jdx in currentNode.children){
                if(currentNode.children[jdx].path === currentPath + "/"){
                    currentNode = currentNode.children[jdx];
                    if(!("children" in currentNode))
                        currentNode.children = [];
                    nav.push(currentNode);
                    break;
                }
            }
        }
        if(this.state.selectedGroup && group){
            if(this.state.selectedGroup.groupid !==group.groupid){
                this.allIntervals.forEach(clearInterval);
            }
        }
        this.setState({groups: nav, selectedGroup: group},() =>{
            this.checkRequestTable()
           
        })
        
    }
    changeVehicle = function (v) {
        window.saveVehicleState(v);
        // this.vehicleSelect.wrappedInstance.setFocusActive();
      };

    downloadReport = (store) =>{
        let str = ""
        // let startDate = moment(this.state.startDate).unix() * 1000
        // let endDate = moment(this.state.endDate).unix() * 1000
        // startDate = moment(startDate, dateFormat).unix() * 1000
        // endDate = moment(endDate, dateFormat).unix() * 1000
        // let datestart = new Date(startDate)
        // let dateend = new Date(endDate)
        // let vehicleIds = []
        // if(this.state.selected && window.selectedItems && window.selectedItems.length !==0){
        //     for(let idx in window.selectedItems) {
        //         if (report.key === "immob_report"){
        //             console.log("Data",window.selectedItems[idx].data);
                    
        //             vehicleIds.push(parseInt(window.selectedItems[idx].data.vehicleno))
        //         }
        //         vehicleIds.push(parseInt(window.selectedItems[idx].data.vehicleid))
        //     }
        // }else if(this.state.selected && window.selectedItems === undefined && window.selectedVehicles && window.selectedVehicles[0]) {
        //     vehicleIds.push(parseInt(window.selectedVehicles[0].id))
        // }


        let vehicleIds = []

            if (this.state.selected && window.selectedItems && window.selectedItems.length !== 0) {
                for (let idx in window.selectedItems) {
                    const item = window.selectedItems[idx].data

                    if (this.state.reporttype === "immob_report") {
                        console.log("Immob Vehicle", item)
                        vehicleIds.push(item.vehicleno) // string, no parseInt
                    } else {
                        vehicleIds.push(parseInt(item.vehicleid))
                    }
                }
            }
            else if (this.state.selected && window.selectedItems === undefined && window.selectedVehicles && window.selectedVehicles[0]) {
                if (this.state.reporttype === "immob_report") {
                    vehicleIds.push(window.selectedVehicles[0].vehicleno)
                } else {
                    vehicleIds.push(parseInt(window.selectedVehicles[0].id))
                }
}
        let starttime = moment(this.state.startDate).unix() * 1000
        let endtime = (moment(this.state.endDate).unix() * 1000) + 1000
        let limit = this.state.limit
        let duration = this.state.duration
        if(!starttime || !endtime || !this.state.reporttype){
            if(!this.state.reporttype) str = "Report"
            if(!starttime || !endtime) str = "Proper Date"
            this.props.props.dispatch({
                type: "ADD_INTOAST",
                data: {
                  name: "Please Select " + str,
                  content: "Please Select " + str,
                  createAt: Date.now(),
                  autoClose: 8000,
                  showError:true
                },
              });
            return
        }
        let oneYearAgo = moment().startOf("day").subtract(365, "days").valueOf()
        if(starttime < oneYearAgo || endtime < oneYearAgo) {
            this.props.props.dispatch({
              type: "ADD_INTOAST",
              data: {
                name: "Data older than 1 year is not available",
                content: "Reports can only be generated for the last 365 days. Please select dates on or after " + moment(oneYearAgo).format("DD-MM-YYYY") + ".",
                createAt: Date.now(),
                autoClose: 8000,
                showError:true
              },
            });
            return;
        }
        if(endtime - starttime > 1000 * 60 * 60 * 24 * 35) {
            this.props.props.dispatch({
              type: "ADD_INTOAST",
              data: {
                name: "You can't select a date range of more than 35 days",
                content: "You can't select date range of more than 35 days",
                createAt: Date.now(),
                autoClose: 8000,
                showError:true
              },
            });
            return;
        }
        if(this.state.reporttype === "gpsdump" && endtime - starttime > 1000 * 60 * 60 * 24 * 30) {
            this.props.props.dispatch({
              type: "ADD_INTOAST",
              data: {
                name: "You can't select a date range of more than 30 days",
                content: "You can't select date range of more than 30 days",
                createAt: Date.now(),
                autoClose: 8000,
                showError:true
              },
            });
            return;
        }
        if(starttime > endtime){
            this.props.props.dispatch({
                type: "ADD_INTOAST",
                data: {
                  name: "Start time should be less than end time",
                  content: "Start time should be less than end time",
                  createAt: Date.now(),
                  autoClose: 8000,
                  showError:true
                },
              });
              return;
        }
        if(this.state.selected && vehicleIds.length === 0 ) {
            this.props.props.dispatch({
                type: "ADD_INTOAST",
                data: {
                  name: "Please select a vehicle",
                  content: "Please select a vehicle",
                  createAt: Date.now(),
                  autoClose: 8000,
                  showError:true
                },
              });
              return;
        }
        if(!this.state.selected &&this.state.selectedGroup && this.state.selectedGroup.groupid <= 2){
            this.props.props.dispatch({
                type: "ADD_INTOAST",
                data: {
                  name: "Not able to process the request ",
                  content: "Not able to process the request for the selected group",
                  createAt: Date.now(),
                  autoClose: 8000,
                  showError:true
                },
              });
              return;
        }
        if(this.state.reporttype === "overspeed" && (!this.state.limit || !this.state.duration) ){
            this.props.props.dispatch({
                type: "ADD_INTOAST",
                data: {
                  name: "Please add speed limit and duration ",
                  content: "Please add speed limit  and duration ",
                  createAt: Date.now(),
                  autoClose: 8000,
                  showError:true
                },
              });
              return;
        }
        if(this.state.reporttype === "gps_report" && !vehicleIds.length) {
            this.props.props.dispatch({
                type: "ADD_INTOAST",
                data: {
                  name: "Please Select a Vehicle",
                  content: "Please select a vehicle to downlad the GPS report",
                  createAt: Date.now(),
                  autoClose: 8000,
                  showError:true
                },
            });
            return
        }
        if(starttime === endtime){
            endtime = endtime + (1000 * 60 * 60 * 24 - 60000)
        }
        let btn = document.getElementsByClassName("drcr-btn")
        btn[0].disabled = true
        this.setState({showDisabled:true})
        
        let groupid = this.state.selectedGroup ? this.state.selectedGroup.groupid : null
        if(!groupid && this.state.groups && this.state.groups.length) groupid = this.state.groups[0].groupid

        let reporttype = this.state.reporttype
        if(reporttype === "trip_report") reporttype = "trip"
        else if(reporttype === "daily_report") reporttype = "daily"
        else if(reporttype === "summary_report") reporttype = "summary"
        else if(reporttype === "distance") reporttype = "distance"
        else if(reporttype === "new_trip_report") reporttype = "blrpolicetrip"
         else if(reporttype === "alarm_report") reporttype = "alarm"
         else if(reporttype === "gpsdump") reporttype = "gpsdump"
         else if(reporttype === "range_report") reporttype = 'range'
         else if(reporttype === "gps_report") reporttype = "gpsdumpaddress"
         else if(reporttype === "immob_report") reporttype="immob"
         else if(reporttype === "ebike_report") reporttype="ecycle_movement"
        // else reporttype = null
        
        const handleSuccess = (resp) =>{
            this.setState({requestSend: true})
            this.checkDownloadRequestTable()
            const currentDate = moment();
            // if( moment(this.state.endDate).isSame(currentDate, 'day')) {
            //     this.setState({endDate: moment()})
            // }

            if (this.state.endDate && moment(this.state.endDate).isValid()) {
                if (moment(this.state.endDate).isSame(currentDate, 'day')) {
                    this.setState({ endDate: currentDate.toDate() });
                }
            }
            
            let time = new Date()
            time = moment(time).unix()*1000
            localStorage.setItem('reportSendTime', time);

        }
        const handleFailure = (resp) => {
            this.setState({requestFailed: true})
            let time = new Date()
            time = moment(time).unix()*1000
            localStorage.setItem('reportSendTime', time);
            this.props.props.dispatch({
                type: "ADD_INTOAST",
                data: {
                  name: "Request Failed",
                  content: "Request Failed",
                  createAt: Date.now(),
                  autoClose: 8000,
                  showError:true
                },
              });
        }
        let body = {
            reporttype: reporttype,
            starttime: starttime,
            endtime: reporttype === "gpsdumpaddress" ?  starttime + (1000 * 60 * 60 * 24) : endtime,
            groupid:this.state.selectedGroup.groupid
        }
        if(this.state.selected && vehicleIds.length){
            body.vehicles = vehicleIds
            body.groupid = this.pgroupid
        }
        if(reporttype === "overspeed") {
            body.meta = {threshold: parseInt(limit),duration:parseInt(duration)}
        }
        
        if(body.reporttype === null){
            this.props.props.dispatch({
                type: "ADD_INTOAST",
                data: {
                  name: "Please select a report",
                  content: "Please select a report",
                  createAt: Date.now(),
                  autoClose: 8000,
                  showError:true
                },
              });
              return;
        }
        ReportAPIs.downloadRequest(body)
        .then(handleSuccess,handleFailure)

    }
    
    download = (data,index) => {
        let reqData = this.state.requestData
        const downloadSuccess = (resp) => {
            reqData[index].link = resp;
            window.open(resp, '_blank');
            this.setState({
                requestData: reqData
            }, () =>{
            })
        }
        const downloadFailure = () => {

        }

        if(data.status === "Completed"){
            let body = {
                reqid: data.reqid,
                reportType: data.reportType
            }
            ReportAPIs.fileDownload(body)
            .then(downloadSuccess,downloadFailure)
        }
    }
    cancelRequest = (data, index) => {
        if(data.status !== "Pending"){
            return
        }
        let body = {
            reqid: data.reqid
        }
        const cancelSuccess = () => {
            let btn = document.getElementsByClassName("drcr-btn")
            btn[0].disabled = false
            localStorage.removeItem("reportSendTime")
            this.setState({showDisabled: false, requestSend: false})
            this.checkRequestTable()
        }
        const cancelFailure = () => {
            this.props.props.dispatch({
                type: "ADD_INTOAST",
                data: {
                  name: "Cancel Request Faild",
                  content: "Cancel request faild. Please try again",
                  createAt: Date.now(),
                  autoClose: 8000,
                  showError:true
                },
              });
        }
        ReportAPIs.cancelRequest(body)
        .then(cancelSuccess,cancelFailure)
    }
    // isLinkAvailable = (data,index) => {
    //    this.state.requestData.map((request,idx) => {
    //        if(data.preqid === request.reqid && request.link){
    //            data.link = request.link
    //         //    data.status = request.status
    //            return true
    //        }
    //    })
    // }
    closePopup = () => {
        this.setState({requestSend: false})
    }
    renderTable = (data,index) =>{
        return( 
            <div className="drcrt-list">
                {this.state.requestData.map((data,index) =>{
                return(
                    <div className="drcrt-item" key={index} style={{background:data.color || "#FFFF"}}>
                        <span>{data.groupname}</span>
                        <span>{data.root_uname}</span>
                        <span>{data.reportType}</span>
                        <span>{moment(data.starttime).format(simpleTimeFormat)}</span>
                        <span>{moment(data.endtime).format(simpleTimeFormat)}</span>
                        <span>{data.vehicleCount}</span>
                        <span>{data.dayCount}</span>
                        <div className="drcrti-alldiv">
                            <div className={Dom.Class({'active':data.status==="Pending" || data.status==="Exists" || data.status ==="Failure" || data.status ==="Running",
                                "done": data.status ==="Completed"}, "drcrti-btn")}
                                onClick ={() =>{this.download(data,index)}}>
                                {data.status === "Completed" ? <a>Download</a> : data.status}
                                {/* {data.status === "Exists" && this.isLinkAvailable(data,index)}  */}
                                {/* {data.status !== "Completed" && data.status !== "Failure" && !data.timer ? <div className="lds-dual-ring"></div> : null} */}
                                {/* { data && data.timer && data.timer.total && data.status !== "Completed" && data.status !== "Failure" && data.timer.total > 1000 ?
                                <div className="drcrti-time">{ data.timer.minutes+" : " +data.timer.seconds}{data.timer.minutes > 0 ? " Mins" : " Secs"}</div>: null}    */}
                            </div>
                        </div>
                        <div className="drcrti-cancel" onClick={() => {this.cancelRequest(data,index)}}>
                            <span className={Dom.Class({'active':data.status==="Pending"},"drcrtic-btn")} >Cancel</span></div>
                    </div>
                )
                })}
        </div>
        )
    }
    // className="drcrt-item"
    render(){
        return(
            <div className="downloadReport">
                <div className="dr-content">
                    <div className="drcr-group">
                        <div className="drcrg-selected">
                            {this.state.selected ? 
                                <div className="drcrgs-select">
                                    <InMultiSelect
                                    ref={ref => { this.vehicleSelect = ref; }}
                                    data={{  storeData: (state) => {
                                        return {
                                        data: (() => {
                                            let newMap = {};
                                            for (let idx in state.vehicleMap) {
                                            if (idx.indexOf("user") === -1) {
                                                newMap[idx] = state.vehicleMap[idx];
                                            }
                                            }
                                            return newMap;
                                        })(),
                                        name: "vehicleno",
                                        id: "vehicleid",
                                    
                                        };
                                    },
                                    key:'vehicle',
                                    singleSelect: this.state.singleselect,
                                    onItemChange: this.changeVehicle.bind(this),
                                    schemaKey: "download_report",
                                    reporttype: this.state.reporttype,
                                    defaultValue: () => {
                                        return {
                                        data:  window.selectedVehicles.map((i) => {
                                            return i.id;
                                        }),
                                        updatedAt:window.selectedVehiclesUpdatedAt,
                                        };
                                    }}} />
                                </div>
                                :
                                <div className="drcrgs-nav">
                                    <GroupNav
                                        props = {this.state}
                                        navigate = {this.navigate}
                                    />
                                </div>
                            }
                            
                        </div>
                        <div className={`toggle ${this.state.selected ? "" : "disabled3"}`}>
                            <DownloadToggle
                                selected = {this.state.selected}
                                toggleSelected = {() => this.setState({selected: !this.state.selected})}
                            />
                        </div>
                    </div>
                    <div className="drc-request">
                        <div className="drcr-type" ref= "reportContainer">
                        <div className="dropdown">
                        <div className={this.state.dropdownOpen ? "dropdown-select-active" :"dropdown-select"} onClick={this.toggleDropdown}>
                            {this.state.reportName ? this.state.reportName : "Select Report" }
                        </div>
                        {this.state.dropdownOpen && (
                            <div className="dropdown-options">
                            {this.getReportType()}
                            {this.addNewReport()}
                            {/* <div
                                className="dropdown-option"
                                onClick={() => this.handleOptionClick("distance", "Distance")}
                            >
                                Distance Report
                            </div> */}
                            </div>
                        )}
                        </div>
                        </div>
                        {this.state.overspeedSelected ? <div className="drcr-speed">
                                <div><input type="number" placeholder="Speed Limit" onChange={(e) => this.setState({limit:e.target.value})}/></div>
                                <div><input type="number" placeholder="Duration" onChange={(e) => this.setState({duration:e.target.value})}/></div>
                            </div>:null}
                        
                        <div className="drcr-date">
                            
                            <div className="drcrd-picker"><DatePicker 
                                // showTimeSelect={this.state.reporttype === "distance" ? false : true}
                                wrapperClassName="datepicker"
                                selected={this.state.startDate}
                                onChange={(e) => this.handleStartDate(e)}
                                dateFormat="dd-MM-yyyy"
                                maxDate= {moment(Date.now()).startOf("day").subtract(0, "days").toDate()}
                            
                            /></div>
                            {this.state.reporttype !== "gps_report" && <div className="drcrd-picker"><DatePicker 
                                // showTimeSelect={this.state.reporttype === "distance" ? false : true}
                                wrapperClassName="datepicker"
                                selected={this.state.endDate}
                                onChange={(e) => this.handleEndDate(e)}
                                dateFormat="dd-MM-yyyy"
                                maxDate= {moment(Date.now()).startOf("day").subtract(0, "days").toDate()}
                            /></div>}
                        </div>
                        { this.state.updateData ? 
                            <div className="drcr-note">
                                <span className="loader"></span>
                                <span className="drcrn-note">Fetching...</span>
                            </div> : 
                            this.state.lastFetched && this.state.requestData && this.state.requestData.length ? 
                            <div className="drcrn-fetched">
                                <span className="fetch"> Last Fetched :</span><span className="fetchTime">{this.state.lastFetched}</span>
                            </div> :null
                        }
                        <div className="drcr-download">
                            <button className={Dom.Class({'active':this.state.requestSend === true || this.state.showDisabled === true}, "drcr-btn")} onClick={this.downloadReport} >{this.state.requestSend ? "Done" :this.state.requestFailed ? "Request Failed" : "Send Request"}</button>
                            {this.state.showDisabled ?<div className="drcrb-note">button disabled for 30 sec</div> :null}
                        </div>
                    </div>
                    
                    {this.state.requestData.length ?(
                    <div className="drc-requestTable">
                        {/* <span className="drcr-heading"> Request Table</span> */}
                       
                            <div className="drcr-table">
                                {
                                    this.reportHead.map((data,index) => {
                                        return(
                                            <div className="drcrt-item-hd" key={index}>
                                                <span>{data.groupname}</span>
                                                <span>{data.root_uname}</span>
                                                <span>{data.reporttype}</span>
                                                <span>{data.starttime}</span>
                                                <span>{data.endtime}</span>
                                                <span>{data.vehicleCount}</span>
                                                <span>{data.dayCount}</span>
                                                <span>{data.status}</span>
                                                <span>{data.action}</span>
                                        </div>        
                                        )
                                    })
                                        
                                }
                                {   
                                    this.renderTable()
                                }
                            </div>
                    </div>
                    ): <div className="drcr-nodata">NO REQUEST DATA </div>
                            }

                </div>
                {this.state.requestSend && this.state.selected ? <div className="popup-overlay">
                    <div className="popup-container">
                        <div className="popup-header">
                        <h2>Request Sent</h2>
                        <button className="close-btn" onClick={() => this.closePopup()}>×</button>
                        </div>
                        <div className="popup-body">
                        Request sent. Please check your parent group: <span>{this.groupname}</span> .
                        </div>
                    </div>
                    </div>: null}
            </div>
        )
    }
}
export default DownloadReport;